import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { memo, useState } from 'react';
import clsx from 'clsx';
import { Button, CheckboxGroup, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, SideBar, SideBarHeader } from 'reaxl';
function FilterCheckboxesExpansion(props) {
  var _Button, _SideBarHeader;
  const [showExpansion, setShowExpansion] = useState(false);
  const handleToggle = event => {
    const {
      onHide,
      onShow
    } = props;
    const eventHandler = showExpansion ? onHide : onShow;
    if (typeof eventHandler === 'function') {
      // Handle the event
      eventHandler(event);
    }

    // update the state
    setShowExpansion(prevState => !prevState);
  };
  const renderCheckboxGroup = () => {
    const {
      collapsed,
      options,
      onOptionChange = () => {},
      value
    } = props;
    const filterCheckboxesClassName = clsx({
      columns: !collapsed,
      'columns-4': !collapsed
    });
    return /*#__PURE__*/_jsx(CheckboxGroup, {
      className: filterCheckboxesClassName,
      labelClassName: "margin-top-0",
      options: options,
      onChange: onOptionChange,
      value: value
    });
  };
  const renderModal = () => {
    const {
      title,
      onOptionsClear = () => {}
    } = props;
    return /*#__PURE__*/_jsx(Modal, {
      bsSize: "large",
      show: showExpansion,
      onHide: handleToggle
    }, void 0, /*#__PURE__*/_jsx(ModalHeader, {
      closeButton: true
    }, void 0, /*#__PURE__*/_jsx(ModalTitle, {}, void 0, title)), /*#__PURE__*/_jsx(ModalBody, {}, void 0, renderCheckboxGroup()), /*#__PURE__*/_jsx(ModalFooter, {}, void 0, /*#__PURE__*/_jsx(Button, {
      onClick: onOptionsClear
    }, void 0, "Clear All"), _Button || (_Button = /*#__PURE__*/_jsx(Button, {
      bsStyle: "primary",
      onClick: handleToggle
    }, void 0, "View Results"))));
  };
  const renderSideBar = () => {
    const sideBarHeader = _SideBarHeader || (_SideBarHeader = /*#__PURE__*/_jsx(SideBarHeader, {
      onHide: handleToggle,
      title: "Back"
    }));
    return /*#__PURE__*/_jsx(SideBar, {
      show: showExpansion,
      onHide: handleToggle,
      header: sideBarHeader,
      className: showExpansion ? 'expanded' : '' // bring side bar forward when see more is clicked
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "padding-horizontal-4"
    }, void 0, renderCheckboxGroup()));
  };
  const {
    collapsed,
    extendedOption,
    onExtendedOptionsClick,
    options,
    ...rest
  } = props;
  delete rest.onOptionChange;
  delete rest.onShow;
  delete rest.onHide;
  delete rest.onOptionsClear;
  delete rest.collapsedTitle;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "filterCheckboxesExpansion"
  }, rest), /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Button, {
    "data-cmp": "lnk-expand",
    onClick: handleToggle,
    bsStyle: "text"
  }, void 0, "See More"), extendedOption && /*#__PURE__*/_jsx(Button, {
    "data-cmp": "cntnr-extnd-opt",
    onClick: event => onExtendedOptionsClick(event, options),
    bsStyle: "text"
  }, void 0, extendedOption)), collapsed ? renderSideBar() : renderModal());
}
export default /*#__PURE__*/memo(FilterCheckboxesExpansion);